module.exports = __webpack_public_path__ + "static/media/music.ceb43e84.svg";